import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes'

/* State shape
{
    loadingState: {
        isLoading: bool,
        success: bool,
        error: Array
    }
    standingsState: {
        standingsData: Object,
        tieBreakingProcedureData: Object,
        currentSeason int
    }
}
*/

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_STANDINGS_DATA)(actionTypes.STANDINGS_DATA_RESPONSE);

const standingsDataReducer = (state = {}, action) => {
    const { payload } = action;

    if (action.type === actionTypes.STANDINGS_DATA_RESPONSE) {
        return Object.assign({}, state, {
            [payload.date]: payload.standingsData
        });
    }

    return state;
};

const tieBreakingProcedureDataReducer = (state = {}, action) => {
    const { payload } = action;

    if (action.type === actionTypes.TIE_BREAKING_PROCEDURE_DATA_RESPONSE) {
        return {
            ...state,
            [payload.season]: payload.tieBreakingProcedureData,
        };
    }

    return state;
}

const currentSeasonReducer = (state = null, action) => {
    const { payload } = action;

    if (action.type === actionTypes.CHANGE_CURRENT_SEASON) {
        return payload.season;
    }

    return state;
};

const standingsStateReducer = combineReducers({
    standingsData: standingsDataReducer,
    tieBreakingProcedureData: tieBreakingProcedureDataReducer,
    currentSeason: currentSeasonReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    standingsState: standingsStateReducer
});

export default reducer;
